import { render, staticRenderFns } from "./AddNewCardPanel.vue?vue&type=template&id=1b9dbc04&"
import script from "./AddNewCardPanel.vue?vue&type=script&lang=js&"
export * from "./AddNewCardPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b9dbc04')) {
      api.createRecord('1b9dbc04', component.options)
    } else {
      api.reload('1b9dbc04', component.options)
    }
    module.hot.accept("./AddNewCardPanel.vue?vue&type=template&id=1b9dbc04&", function () {
      api.rerender('1b9dbc04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/profile/panels/AddNewCardPanel.vue"
export default component.exports